import signIn from "@pv/auth/signIn";
import { SILENT_REDIRECT_URI } from '@pv/constants';

(async () => {
    const extras = { prompt: 'none' };
    await signIn(SILENT_REDIRECT_URI, { extras });
})();
